import script from "./BookingHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./BookingHeader.vue?vue&type=script&lang=ts&setup=true"

import "./BookingHeader.vue?vue&type=style&index=0&id=1e4ab704&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e4ab704"]])

export default __exports__